<template>
  <ProductSettingsSmart
    v-if="compositionMode === CompositionMode.SMART"
    @on-close="modalInstance.close"
    @on-dismiss="modalInstance.dismiss"
  />
  <ProductSettingsAdvanced
    v-else-if="compositionMode === CompositionMode.ADVANCED"
    @on-close="modalInstance.close"
    @on-dismiss="modalInstance.dismiss"
  />
</template>

<script setup lang="ts">
import { useCompositionStore } from 'commons/stores/composition';
import ProductSettingsSmart from './smart/ProductSettingsSmart.vue';
import { CompositionMode } from '@spreadgroup/common-partner-lib/composition';
import ProductSettingsAdvanced from './advanced/ProductSettingsAdvanced.vue';
import { computed } from 'vue';

interface Props {
  modalInstance: {
    close: () => void;
    dismiss: () => void;
  };
  data?: Record<string, unknown>;
}

defineProps<Props>();

const compositionStore = useCompositionStore();
const compositionMode = computed(() => compositionStore.mode);
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/styleguide/links';
</style>
